<template>
  <div>
    <Dialog :visible.sync="dialogVisible" @close="closeOrderDialog">
      <section class="super-audio-bag-dialog">
        <header>
          购买配音包 <span class="title-des">如叠加购买配音包，则先消耗较早日期的条数</span>
        </header>
        <div class="list">
          <div class="item" v-for="item,index in priceList" :key="index" :class="{active: index === currentIndex}" @click="()=>changeBag(index, item)">
            <div class="item-title">
              <span class="number">{{item.num_dubbings}}</span>条<span v-if="item.num_free_dubbings">送{{item.num_free_dubbings}}条</span>
              <Tooltip v-if="item.promotion_title" class="newer">{{item.promotion_title}}</Tooltip>
            </div>
            <div class="item-money">{{item.package_money_num}}元</div>
            <div class="item-date">有效期{{item.date}}</div>
          </div>
        </div>
        <footer>
          <button class="pay-button" @click="payBag">购买配音包</button>
        </footer>
      </section>
    </Dialog>
    <PayDialog v-show="payVisible" :payVisible="payVisible" @close="closePayDialog" :money="money" :tradeNo="tradeNo" :noSlot="true"></PayDialog>
  </div>
</template>

<script>
import PayDialog from 'components/pay-dialog'
import Dialog from './svoice-dialog'
import { pricingDubbingPackageList } from 'api/pricing.js'
import { formatMoney } from 'utils/utils'
import Tooltip from '@/components/tooltip.vue'
import { createDubbingPackageOrder } from 'api/order.js'

export default {
  name: 'super-audio-bag-dialog',
  props: {
    item: Object
  },
  data() {
    return {
      currentIndex: 0,
      priceList: [],
      dateMap: {
        1: '个小时',
        2: '天',
        3: '个月',
        4: '年'
      },
      tradeNo: '',
      money: 0,
      dialogVisible: false,
      payVisible: false,
      bag: {},
      tradeNoMap: {}
    }
  },
  components: {
    Dialog,
    Tooltip,
    PayDialog
  },
  created() {
    this.pricingDubbingPackageList()
    this.dialogVisible = true
  },
  methods: {
    // closedDialog () {
    //   console.log('closedDialog')
    //   this.$emit('close')
    //   this.dialogVisible = false
    //   clearInterval(this.timer)
    //   this.payCode  = ''
    // },
    payBag () {
      this.payVisible = true
      const info = this.tradeNoMap[this.currentIndex]
      if (info) {
        this.tradeNo = info.tradeNo
        this.money = info.money
      } else {
        this.createDubbingPackageOrder()
      }
    },
    async createDubbingPackageOrder () {
      this.$showLoading()
      const result = await createDubbingPackageOrder({ id: this.bag.dubbing_package_id })
      console.log(result.data.trade_no, 'result.data.trade_no')
      this.orderInfo = {}
      this.tradeNo = result.data.trade_no
      this.money = parseFloat(this.bag.package_money_num)
      this.tradeNoMap[this.currentIndex] = {
        tradeNo: result.data.trade_no,
        money: parseFloat(this.bag.package_money_num)
      }
      this.$hideLoading()
    },
    closePayDialog (item) {
      this.payVisible = false
      if (item === 'paid') {
        this.$store.dispatch('global/setBagPaid', true)
        this.$store.dispatch('global/setBagFlag', false)
      }
    },
    closeOrderDialog () {
      this.$store.dispatch('global/setBagFlag', false)
    },
    changeBag (index, item) {
      this.currentIndex = index
      console.log(item)
      this.bag = item
    },
    async pricingDubbingPackageList () {
      const res = await pricingDubbingPackageList()
      const priceList = res.data && res.data.map((ele) => {
        ele.package_money_num = formatMoney(ele.package_money_num)
        ele.date = ele.dubbing_package_duration + this.dateMap[ele.dubbing_package_duration_unit]
        return ele
      })
      this.priceList = priceList
      if (priceList.length) {
        this.changeBag(0, priceList[0])
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.super-audio-bag-dialog {
  width: 600px;
  padding: 30px;
  box-sizing: border-box;
  font-size: 14px;
  color: #555555;
  header {
    .title-des {
      color: #999999;
      margin-left: 10px;
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 15px;
    .item {
      width: 160px;
      height: 100px;
      border-radius: 6px;
      border: 1px solid #EEEEEE;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      cursor: pointer;
      color: #999999;
      &.active {
        background: #FFFBF0;
        border: 1px solid #F7B500;
      }
      .item-title {
        margin-bottom: 5px;
        color: #FA6400;
        position: relative;
        .newer {
          transform: translate(100%);
          top: -15px;
        }
        .number {
          font-size: 30px;
          line-height: 30px;
          position: relative;
          top: 2px;
        }
      }
      .item-money {
        color: #999999;
        font-size: 20px;
      }
    }
  }
  footer {
    text-align: center;
    padding-top: 10px;
    .pay-button {
      color: #fff;
      width: 330px;
      height: 40px;
      background: #4E6EFF;
      border-radius: 4px;
      font-size: 16px;
    }
  }
}
</style>
